import type { PositionStatus } from '@Store/types/dashboard'

import PricePositionCard, { DASHBOARD_PRICE_POSITION_EVENTS } from './card'
import ReportDetail from './report-detail'

function PricePosition({
  position,
  isReportDetail,
  isCheap,
  categoryId,
  brandId,
  view,
}: {
  position: PositionStatus | undefined
  isReportDetail?: boolean
  isCheap?: any
  categoryId?: string
  brandId?: string
  view?: string
}): JSX.Element {
  return isReportDetail ? (
    <ReportDetail
      position={position}
      isCheap={isCheap}
      categoryId={categoryId}
      brandId={brandId}
    />
  ) : (
    <PricePositionCard
      position={position}
      view={view}
      eventNames={DASHBOARD_PRICE_POSITION_EVENTS}
    />
  )
}

export default PricePosition
